// store/task.ts
import { create } from "zustand";

/** 태스크 진행 상태 */
export type TaskStateValue = "pending" | "success" | "error";

export interface Task {
  id: string;
  name: string;
  job?: string;
  state: TaskStateValue;
}

interface TaskStore {
  tasks: Task[];
  volumeSuccessTick: number;

  addTask: (task: Omit<Task, "state"> & Partial<Pick<Task, "state">>) => void;
  updateTaskState: (id: string, state: TaskStateValue) => void;
  removeTask: (id: string) => void;
  clearTasks: () => void;
}

export const useTaskStore = create<TaskStore>((set, get) => ({
  tasks: [],
  volumeSuccessTick: 0,

  addTask: (taskInput) =>
    set((s) => {
      const state: TaskStateValue = taskInput.state ?? "pending";
      const idx = s.tasks.findIndex((t) => t.id === taskInput.id);

      if (idx === -1) {
        return { tasks: [...s.tasks, { ...taskInput, state }] };
      }

      const next = s.tasks.slice();
      next[idx] = { ...next[idx], ...taskInput, state };
      return { tasks: next };
    }),

  updateTaskState: (id, state) =>
    set((s) => {
      const prev = s.tasks.find((t) => t.id === id);
      if (!prev) return s;

      // 이미 같은 상태면 아무것도 안 함
      if (prev.state === state) return s;

      const nextTasks = s.tasks.map((t) => (t.id === id ? { ...t, state } : t));

      const becameSuccess =
        prev.state !== "success" &&
        state === "success" &&
        prev.job?.includes("Volume");

      return {
        tasks: nextTasks,
        volumeSuccessTick: becameSuccess
          ? s.volumeSuccessTick + 1
          : s.volumeSuccessTick,
      };
    }),

  removeTask: (id) =>
    set((s) => ({ tasks: s.tasks.filter((x) => x.id !== id) })),

  clearTasks: () => set({ tasks: [], volumeSuccessTick: 0 }),
}));
